/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/NewConnection" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Link } from "VSSUI/Link";
import { INewConnectionProps } from "Wit/Settings/BoardsExternalIntegration/components/common/NewConnection.Props";
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";
import { GitHubIntegrationCIActions, publishGitHubIntegrationTelemetry } from "Wit/Settings/BoardsExternalIntegration/telemetry/GitHub";
import { createAuthRequest } from "Wit/Settings/BoardsExternalIntegration/utils/ConnectionUtil";

export class NewConnection extends VssComponent<INewConnectionProps> {
    private readonly _connectButtonRef = React.createRef<Button>();
    private readonly _patLinkRef = React.createRef<Link>();

    constructor(props: INewConnectionProps, context: IVssComponentContext) {
        super(props, context);
    }

    public componentDidMount() {
        // We use requestAnimationFrame here and all of the other places on GitHubAdmin UX while setting focus to prevent the
        // 'Actions' button stealing focus back from the panel
        requestAnimationFrame(() => {
            if (this.props.disableOAuth) {
                // If OAuth is disabled, focus on PAT link
                this._patLinkRef.current && this._patLinkRef.current.focus();
            } else {
                this._connectButtonRef.current && this._connectButtonRef.current.focus();
            }
        });
    }

    public render(): JSX.Element {
        return (
            <div className="new-connection-container">
                <Button
                    className={"new-connection-action"}
                    primary={true}
                    text={Resources.LinkYourGitHub}
                    onClick={this._onConnectButtonClicked}
                    ref={this._connectButtonRef}
                    disabled={this.props.disableOAuth}
                />

                <div className="alternative-message">{Resources.NewConnection_alternative_message}</div>

                <div className="alternate-authentication-option">
                    <Link onClick={this._onPatClick} ref={this._patLinkRef}>
                        {Resources.PAT}
                    </Link>
                </div>

                <div className="alternate-authentication-option">
                    <Link onClick={this._onUsingGheClick}>{Resources.GitHubEnterprise}</Link>
                </div>
            </div>
        );
    }

    private readonly _onConnectButtonClicked = (): void => {
        if (this.props.onConnectButtonClick) {
            this.props.onConnectButtonClick();
        }

        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_UNIFIEDINSTALL);

        createAuthRequest(this.context.pageContext, (error: Error) => {
            this.props.onOAuthError && this.props.onOAuthError(error);
        });
    };

    private readonly _onPatClick = (): void => {
        this.props.showPanel(Panel.Pat);
        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_PAT);
    };

    private readonly _onUsingGheClick = (): void => {
        this.props.showPanel(Panel.EnterpriseAuthenticationMethod);
        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_USING_GHE);
    };
}
